import { RestClient } from '@pegasus/rest-client';
export var getTopPicks = function (gender) {
    return RestClient.get("/api/phoenix/search/top-picks/articles")
        .withClientType('web')
        .withQueryParameters({
        page: 0,
        personalized: true,
        size: 10,
        sort: gender,
    })
        .withHeaders({
        'X-Touchpoint': 'tp4u-carousel',
    })
        .send()
        .then(function (req) { return req.json(); });
};
